import { formatDay } from 'pages/data-import/utils';
import { AccountCell, RiskLabel, TiktokIdCell, UidCell } from '../components/cells';
import IssueTable, { IssueField } from '../components/issue-table';
import { MissingRow } from '../types';
import { useIssueList } from '../use-issue-list';
import { formatCount } from '../utils';

// Tổng 1.100px, vừa khung nội dung của màn 1440. Cột Rủi ro rộng 195px để nhãn nằm trên hai dòng.
const FIELDS: IssueField<MissingRow>[] = [
  {
    key: 'tiktokUsername',
    title: 'TikTok ID',
    width: 145,
    render: (row) => <TiktokIdCell username={row.tiktokUsername} />,
  },
  {
    key: 'tiktokUid',
    title: 'UID',
    width: 165,
    render: (row) => <UidCell uid={row.tiktokUid} />,
  },
  {
    key: 'user',
    title: 'Tài khoản app',
    width: 160,
    render: (row) => <AccountCell user={row.user} />,
  },
  {
    key: 'groupName',
    title: 'Nhóm',
    width: 110,
    render: (row) => row.groupName || '—',
  },
  {
    key: 'lastSeen',
    title: 'Thấy lần cuối',
    width: 105,
    render: (row) => formatDay(row.lastSeen),
  },
  {
    key: 'filesMissed',
    title: 'Số file vắng',
    width: 95,
    align: 'right',
    render: (row) => formatCount(row.filesMissed ?? 0),
  },
  {
    key: 'diamondsLast30',
    title: 'KC 30 ngày cuối',
    width: 125,
    align: 'right',
    render: (row) =>
      row.diamondsLast30Estimated ? (
        <span title="Có phần ước tính: số của file tháng hoặc số cộng dồn được chia đều cho các ngày">
          ≈ {formatCount(row.diamondsLast30 ?? 0)}
        </span>
      ) : (
        formatCount(row.diamondsLast30 ?? 0)
      ),
  },
  {
    key: 'risk',
    title: 'Rủi ro',
    width: 195,
    render: () => <RiskLabel />,
  },
];

const rowKey = (row: MissingRow) => String(row.tiktokUid);

/**
 * Tab "Vắng khỏi file": Creator từng có trong file nhưng không có trong giai đoạn mới nhất
 * (lần cuối thấy cách không quá 90 ngày, không tính người đã nằm ở tab Đã rời đại lý).
 */
const MissingTab = () => {
  const list = useIssueList<MissingRow>('missing', 'Không tải được danh sách Vắng khỏi file');
  return (
    <IssueTable
      list={list}
      fields={FIELDS}
      rowKey={rowKey}
      searchPlaceholder="Tìm TikTok ID, UID hoặc tên"
      searchLabel="Tìm theo TikTok ID, UID hoặc tên trong app"
      note={
        <>
          Creator từng có trong file TikTok nhưng không có trong giai đoạn mới nhất. Chỉ tính
          người thấy lần cuối trong vòng 90 ngày và chưa nằm ở tab Đã rời đại lý.
        </>
      }
    />
  );
};

export default MissingTab;
